module.exports = __webpack_public_path__ + "assets/img/bigbank-logo.1f18366b.png";